module.exports = __webpack_public_path__ + "img/mobileculture3.d613d5dc.png";